import {useTranslation} from 'react-i18next'
import {MenuItem} from './MenuItem'
import {useAuth} from '../../../../../app/modules/auth'
import {MenuInnerWithSub} from './MenuInnerWithSub'
import {useAppDispatch} from '../../../../../redux/hooks'
import {UserMsgCount} from '../../../../../redux/Slice/chatSlice'
import {useCallback, useEffect} from 'react'

export function AdminMenu() {
  const {t} = useTranslation()
  const {hasPermission} = useAuth()
  const dispatch = useAppDispatch()
  // const {msgCount} = useAppSelector((state) => state.chat)

  const fetchMessageCount = useCallback(() => {
    dispatch(UserMsgCount())
  }, [dispatch])

  useEffect(() => {
    fetchMessageCount()
  }, [fetchMessageCount])

  return (
    <>
      {hasPermission('membership-list') && (
        <MenuInnerWithSub
          title={t('LABEL.MEMBERSHIP')}
          to=''
          menuPlacement='bottom-end'
          menuTrigger='click'
          hasArrow={true}
          fontIcon=''
        >
          {hasPermission('membership-list') && (
            <MenuItem
              to='/admin/memberships'
              fontIcon='fa fa-users text-white mx-2'
              title={t('LABEL.MEMBERSHIP')}
            />
          )}
          {hasPermission('membership-list') && (
            <MenuItem
              to='/admin/arch-mems'
              fontIcon='fa fa-archive text-white mx-2'
              title={t('LABEL.ARCHIVED', {name: t('LABEL.MEMBERSHIP')})}
            />
          )}
        </MenuInnerWithSub>
      )}

      {(hasPermission('news-list') ||
        hasPermission('event-list') ||
        hasPermission('survey-list')) && (
        <MenuInnerWithSub
          title={t('LABEL.COMMUNICATION')}
          to=''
          menuPlacement='bottom-end'
          menuTrigger='click'
          hasArrow={true}
          fontIcon=''
        >
          {hasPermission('news-list') && (
            <MenuItem
              to='/admin/news'
              fontIcon='fa fa-newspaper text-white mx-2'
              title={t('LABEL.NEWS_ANNOUNCEMENT')}
            />
          )}
          {hasPermission('event-list') && (
            <MenuItem
              to='/admin/events'
              fontIcon='fa fa-calendar-check text-white mx-2'
              title={t('EVENT.EVENTS')}
            />
          )}
          {hasPermission('survey-list') && (
            <MenuItem
              to='/admin/surveys'
              fontIcon='fa fa-clipboard-list text-white mx-2'
              title={t('LABEL.SURVEYS')}
            />
          )}
          {hasPermission('news-list') && (
            <MenuItem
              to='/admin/arc-news'
              fontIcon='fa fa-archive text-white mx-2'
              title={t('LABEL.ARCHIVED', {name: t('LABEL.NEWS_ANNOUNCEMENT')})}
            />
          )}
        </MenuInnerWithSub>
      )}

      {/* ADMINISTRATION MENU */}
      {(hasPermission('users-list') ||
        hasPermission('roles-list') ||
        hasPermission('membership-category-list') ||
        hasPermission('membership-thematic-list') ||
        hasPermission('municipality-list') ||
        hasPermission('survey-type-list')) && (
        <MenuInnerWithSub
          title={t('MENU.ADMINISTRATION')}
          to=''
          menuPlacement='bottom-start'
          menuTrigger='click'
          hasArrow={true}
        >
          {/* users */}
          {(hasPermission('users-list') || hasPermission('roles-list')) && (
            <MenuInnerWithSub
              title={t('MENU.USERS')}
              to=''
              fontIcon='fa fa-users'
              hasArrow={true}
              menuPlacement='right-start'
              menuTrigger={`{default:'click', lg: 'hover'}`}
            >
              {hasPermission('users-list') && (
                <MenuItem
                  to='/users'
                  fontIcon='fa fa-users text-white mx-2'
                  title={t('MENU.USERS')}
                />
              )}
              {hasPermission('roles-list') && (
                <MenuItem
                  to='/roles-list'
                  fontIcon='fa fa-lock-open text-white'
                  title={t('MENU.ROLES')}
                />
              )}
            </MenuInnerWithSub>
          )}
          {/* tools */}
          {(hasPermission('membership-category-list') ||
            hasPermission('membership-thematic-list') ||
            hasPermission('municipality-list') ||
            hasPermission('survey-type-list')) && (
            <MenuInnerWithSub
              title={t('MENU.TOOLS')}
              to=''
              fontIcon='fa fa-tools'
              hasArrow={true}
              menuPlacement='right-start'
              menuTrigger={`{default:'click', lg: 'hover'}`}
            >
              {hasPermission('membership-category-list') && (
                <MenuItem
                  to='/admin/mem-cats'
                  fontIcon='fa fa-tags text-white'
                  title={t('LABEL.MEMBERSHIPS')}
                />
              )}
              {hasPermission('membership-thematic-list') && (
                <MenuItem
                  to='/admin/thematics'
                  fontIcon='fa fa-people-group text-white'
                  title={t('LABEL.THEMATIC_COMMUNITIES')}
                />
              )}
              {hasPermission('municipality-list') && (
                <MenuItem
                  to='/admin/municipalities'
                  fontIcon='fa fa-layer-group text-white'
                  title={t('LABEL.MUNICIPALITY')}
                />
              )}
              {hasPermission('survey-type-list') && (
                <MenuItem
                  to='/admin/survey-types'
                  fontIcon='fa fa-poll text-white'
                  title={t('LABEL.SURVEY_TYPE')}
                />
              )}
            </MenuInnerWithSub>
          )}
        </MenuInnerWithSub>
      )}
      {/* END OF ADMINISTRATION MENU */}

      {/* <MenuItem
        to='/chat/ad-chat-room'
        title={
          <span className='position-relative'>
            {t('LABEL.CHAT')}
            <span className='badge badge-circle bg-danger position-absolute top-0 text-white translate-middle'>
              {msgCount}
            </span>
          </span>
        }
      /> */}
    </>
  )
}
